import { SharedConstants } from '@formbird/types';
const logger = console;
const FORBIDDEN_ERROR = 'ForbiddenError';
const NOT_FOUND_ERROR = 'NotFoundError';
const DELETED_ERROR = 'DeletedError';
const FORBIDDEN_MESSAGE = 'Access Restricted';
const FORBIDDEN_TEMPLATE_MESSAGE = 'Access to the template for this document is restricted and no alternate template ' +
    'is configured. Please configure an alternate template to be able to access this document';
const SERVER_UNRESPONSE_ERROR = 'ServerUnResponseError';
export class UtilError {
    static createError(message, name) {
        logger.error(message);
        const err = new Error(message);
        err.name = name;
        return err;
    }
    static createErrorObject(err) {
        // if the error is a string, create an error object. Otherwise return the error
        if (err instanceof Error) {
            return err;
        }
        else if (typeof err === 'string' || err instanceof String) {
            return new Error(err.toString());
        }
    }
    static createForbiddenError(doc, actionType) {
        let message;
        if (doc) {
            if (doc.systemHeader &&
                doc.systemHeader.systemType === SharedConstants.SYSTEM_TYPE_TEMPLATE &&
                actionType === SharedConstants.OPERATION_TYPE_READ) {
                message = FORBIDDEN_TEMPLATE_MESSAGE;
            }
            else {
                message = actionType + ' access denied on document ' + doc.documentId;
            }
        }
        return this.createError(message, FORBIDDEN_ERROR);
    }
    static limitErrorMessage(message) {
        if (message && message.length > SharedConstants.DEFAULT_MESSAGE_LENGTH) {
            message = message.substring(0, SharedConstants.DEFAULT_MESSAGE_LENGTH) + '...';
        }
        return message;
    }
}
UtilError.NOT_FOUND_ERROR = NOT_FOUND_ERROR;
UtilError.DELETED_ERROR = DELETED_ERROR;
UtilError.FORBIDDEN_MESSAGE = FORBIDDEN_MESSAGE;
UtilError.FORBIDDEN_TEMPLATE_MESSAGE = FORBIDDEN_TEMPLATE_MESSAGE;
UtilError.FORBIDDEN_ERROR = FORBIDDEN_ERROR;
UtilError.SERVER_UNRESPONSE_ERROR = SERVER_UNRESPONSE_ERROR;
